import React, { useContext, useEffect, useState } from "react";
import Aos from "aos";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import Images from "../../Helpers/Images";
import { Auth } from "../../Contexts/AuthContext";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown, IconButton } from "rsuite";
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { Notification, toaster } from "rsuite";
import CustomLoader from "../comman/Loader/CustomLoader";
import { MdOutlineSpeakerNotesOff } from "react-icons/md";
function MyCampaign({ searchQuery = "" }) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { auth } = useContext(Auth);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredData(data);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = data.filter(
        (item) =>
          item?.campaign_title?.toLowerCase().includes(query) ||
          item?.status?.toLowerCase().includes(query) ||
          auth?.user?.company_name?.toLowerCase().includes(query)
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, data, auth?.user?.company_name]);

  // getting data from api
  const getMycampaignData = () => {
    let config = {
      url: ApiUrl.myCampaign,
      method: "GET",
    };
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        setData(res?.data?.data);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    Aos.init({});
    getMycampaignData();
  }, []);

  const handleEdit = (item) => {
    const slug = item?.campaign_title.replace(/\s+/g, "-").toLowerCase();
    navigate(`/brand/edit-campaign/${slug}`, {
      state: {
        title: item?.campaign_title || item?.campaign_name,
        item: item,
      },
    });
  };

  const handleDeleteMyCampaign = () => {
    if (!selectedId) return;
    console.log("selectedId", selectedId);

    let config = {
      url: ApiUrl.deleteMyCampaign,
      method: "DELETE",
      body: {
        campaign_id: selectedId,
      },
    };

    APIRequest(
      config,
      (res) => {
        toaster.push(
          <Notification type="success" header="Success" closable>
            {res ? res.message : "Deleted Successfully"}
          </Notification>,
          { placement: "topCenter" }
        );
        setOpenDropdownIndex(null);
        setShow(false);
        getMycampaignData();
      },
      (err) => {
        toaster.push(
          <Notification type="error" header="Error" closable>
            {err?.response?.data?.message || "Failed to delete campaign."}
          </Notification>,
          { placement: "topCenter" }
        );
        console.log(err);
      }
    );
  };
  const handleClose = () => setShow(false);
  // date format
  function formatDate(dateString) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  }
  const hasCampaigns = data.length > 0;
  const hasSearchResults = filteredData.length > 0;
  const isSearching = searchQuery.trim() !== "";
  return (
    <>
      <CustomLoader visible={isLoading} />
      {hasSearchResults ? (
        <div className="myCampaignwrapper">
          {filteredData?.map((item, index) => (
            <div
              className="myCampaign-box"
              data-aos="fade-up"
              data-aos-duration="2000"
              key={`brandMyCampaign${index}`}
            >
              <Link
                to="/campagin-detail"
                state={{ product: item }}
                className="myCampaign-box-inner"
              >
                {/* {  console.log("iteeemmmmmm haaiiiiiiiiiiiiiiiiiiiii",item)} */}
                <div className="b-campaign-box-img">
                  <img src={item?.campaign_logo_url} alt="product-img" />
                </div>
                <div className="b-Campaign-content">
                  <div className="heading">
                    <h6 className="product-name">{auth?.user?.company_name}</h6>
                    <p className="p-title">{item?.campaign_title}</p>
                  </div>
                  <div className="list-wrapper">
                    <div className="list-name">
                      <span>Followers</span>
                      <span className="title">
                        {item?.campaign_platform &&
                        Array.isArray(item.campaign_platform) &&
                        item?.campaign_platform?.length > 0
                          ? `${item?.campaign_platform[0]?.social_engagement_data?.follower}+`
                          : "Not Selected"}
                      </span>
                    </div>
                    <div className="list-name">
                      <span>Engagement</span>
                      <span className="title">
                        {item?.campaign_platform &&
                        Array.isArray(item.campaign_platform) &&
                        item?.campaign_platform?.length > 0
                          ? `${item?.campaign_platform[0]?.social_engagement_data?.engagement}%+`
                          : "Not Given"}
                      </span>
                    </div>
                  </div>
                  <div className="othersBox">
                    <div className="social-box">
                      <p className="title">Platforms : </p>
                      <span>
                        {item?.campaign_platform?.length > 0
                          ? item.campaign_platform.map((platform, index) => (
                              <img
                                key={index}
                                src={
                                  platform?.logo
                                    ? platform.logo
                                    : "/default-platform.png"
                                }
                                alt={platform?.name}
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  objectFit: "contain",
                                }}
                              />
                            ))
                          : "Not Selected"}
                      </span>
                    </div>
                    <div className="status-box">
                      <p className="title">status : </p>
                      <span
                        style={{
                          marginLeft: "5px",
                          color: () => {
                            const status = item?.status?.toLowerCase();
                            return status === "draft"
                              ? "#fa9a44"
                              : status === "active"
                              ? "#189f8e"
                              : status === "pending"
                              ? "#098af2"
                              : status === "completed"
                              ? "#ff2121"
                              : "black";
                          },
                        }}
                      >
                        {item?.status}
                      </span>
                    </div>
                    <div className="dateBox">
                      <p className="title">Created At : {"  "}</p>
                      <span className=""> {formatDate(item?.created_at)}</span>
                    </div>
                  </div>
                </div>
              </Link>
              <div className="action-btn-box">
                <IconButton
                  icon={<BsThreeDotsVertical />}
                  appearance="subtle"
                  className="actionBtn"
                  onClick={() =>
                    setOpenDropdownIndex(
                      openDropdownIndex === index ? null : index
                    )
                  }
                />
                {openDropdownIndex === index && (
                  <Dropdown.Menu className="actionBtnDropdown">
                    <Dropdown.Item onClick={() => handleEdit(item)}>
                      <i className="rs-icon rs-icon-edit"></i> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setSelectedId(item?.id);
                        setShow(true);
                      }}
                    >
                      <i className="rs-icon rs-icon-trash"></i> Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-results-section">
          {isSearching ? (
            <>
              <MdOutlineSpeakerNotesOff className="icon" />
              <h5 className="">No campaigns found</h5>
              <p className="">
                No campaigns match "{searchQuery}". Try different keywords or
                check your spelling.
              </p>
            </>
          ) : !hasCampaigns ? (
            <>
              <img src={Images.noAccount} alt="no campaigns" className="mb-3" />
              <p className="text-muted">
                No Campaigns Yet. First Add Campaigns
              </p>
            </>
          ) : null}
        </div>
      )}
      {/* delete modal */}
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="deleteWishlist-modal"
      >
        <Modal.Body>
          <p className="ConfirmationTxt">
            Are You Sure You Want To Delete This Campaign ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="no-btn">
            No
          </Button>

          <Button className="yes-btn" onClick={handleDeleteMyCampaign}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MyCampaign;
